exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.delivery-zone-table .table thead th:nth-child(6){\n  pointer-events: none;\n}\n", ""]);

// exports
